import { useEffect } from "react";
import { supabase } from "./lib/supabase";

const SESSION_VISIT_KEY = "itinex_visit_tracked";

export default function AnalyticsTracker() {
  useEffect(() => {
    const status = sessionStorage.getItem(SESSION_VISIT_KEY);

    if (status === "pending" || status === "done") return;

    sessionStorage.setItem(SESSION_VISIT_KEY, "pending");

    const trackVisit = async () => {
      try {
        const { error } = await supabase.functions.invoke("track-visit", {
          body: {
            path: window.location.pathname,
            full_url: window.location.href,
            referrer: document.referrer || null,
            browser_language: navigator.language || null,
            screen_size: `${window.screen.width}x${window.screen.height}`,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || null,
            user_agent: navigator.userAgent || null,
          },
        });

        if (error) {
          console.error("Visit tracking failed:", error);
          sessionStorage.removeItem(SESSION_VISIT_KEY);
          return;
        }

        sessionStorage.setItem(SESSION_VISIT_KEY, "done");
      } catch (error) {
        console.error("Visit tracking failed:", error);
        sessionStorage.removeItem(SESSION_VISIT_KEY);
      }
    };

    trackVisit();
  }, []);

  return null;
}